var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","appear":""}},[_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view',{staticClass:"view"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }